export default __webpack_public_path__ + "static/poster-7230c9d85c2003290a93847d6efca580.png";